import { Component } from '@angular/core';


@Component({
  selector: 'app-details-cra',
  templateUrl: './details-cra.component.html',
  styleUrls: ['./details-cra.component.css']
})
export class DetailsCraComponent {



 

}
